import { IActionFn, IPageData } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';
import store from '@/store';

// 查询当前组织下的数字资产类目列表
export const queryDigitalDefs: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDigitalDefs', { ...state.list, loading: true });
    const res = await $http.post('/v1/asset/digitaldef/list', payload);
    commit('setDigitalDefs', { data: res });
  } catch (e) {
    commit('setDigitalDefs', { data: [] });
  }
};

// 查询系统已经发布的数字资产类目
export const queryPublishedDefs: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setPublishedDefs', { ...state.list, loading: true });
    const res = await $http.post('/v1/asset/digitaldef/publishedsyslist', payload);
    commit('setPublishedDefs', { data: res });
  } catch (e) {
    commit('setPublishedDefs', { data: [] });
  }
};

// 查询数字资产类目详情
export const queryDigitalDefDetail: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    const { code, keep = false } = payload;
    const initState = keep ? { ...state.detail, loading: true } : { data: null, loading: true };
    commit('setDigitalDefDetail', initState);
    const res = await $http.get(`/v1/asset/digitaldef/${code}/detail`);
    commit('setDigitalDefDetail', { data: res });
  } catch (e) {
    commit('setDigitalDefDetail', { data: null });
  }
};

// 查询数字资产类目修改日志
export const queryDigitalDefLogs: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    const { code, ...rest } = payload;
    commit('setDigitalDefLogs', { ...state.logs, loading: true });
    const res: IPageData = await $http.post(`/v1/asset/digitaldef/${code}/updatelog`, rest);
    commit('setDigitalDefLogs', { data: res.list, pageNum: res.pageNum, pageSize: res.pageSize, total: res.total });
  } catch (e) {
    commit('setDigitalDefLogs', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 查询已发布的系统数字资产属性列表
export const queryDigitalPublishedAttrs: IActionFn<IModuleState> = async ({ commit, state }) => {
  try {
    commit('setDigitalPublishedAttrs', { ...state.publishedAttrs, loading: true });
    const res = await $http.get('/v1/data/asset/digitalattr/publishedlist');
    commit('setDigitalPublishedAttrs', { data: res });
  } catch (e) {
    commit('setDigitalPublishedAttrs', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 新增数字资产类目
export const addDigitalDef: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post('/v1/asset/digitaldef/add', payload);
    store.commit('common/setToast', { visible: true, text: '新增成功' });
  } finally {
    commit('setLoading', false);
  }
};

// 编辑数字资产类目
export const editDigitalDef: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post('/v1/asset/digitaldef/update', payload);
    store.commit('common/setToast', { visible: true, text: '编辑成功' });
  } finally {
    commit('setLoading', false);
  }
};

// 发布系统级数字资产类目
export const publishDigitalDef: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/asset/digitaldef/publish', payload);
    store.commit('common/setToast', { visible: true, text: '发布成功' });
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 删除数字资产类目
export const deleteDigitalDef: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/asset/digitaldef/delete', payload);
    store.commit('common/setToast', { visible: true, text: '删除成功' });
  } finally {
    commit('setConfirm', { visible: false });
  }
};
